function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.113 0C4.091 0 0 3.928 0 8.75s4.09 8.75 9.113 8.75c5.022 0 9.113-3.928 9.113-8.75S14.136 0 9.113 0zm0 1.75c4.037 0 7.29 3.124 7.29 7s-3.253 7-7.29 7-7.29-3.124-7.29-7 3.253-7 7.29-7zm-.911 2.625v3.5H4.557v1.75h3.645v3.5h1.822v-3.5h3.646v-1.75h-3.646v-3.5H8.202z"
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none"
  }, props), _ref);
}

export default SvgPlus;